export default "__VITE_ASSET__2b036f56__"